import type { ButtonHTMLAttributes } from 'react';

export interface IconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  /** Accessible name; also used as the tooltip. */
  label: string;
  active?: boolean;
  badge?: number | string;
}

export function IconButton({
  label,
  active,
  badge,
  className,
  children,
  type = 'button',
  ...rest
}: IconButtonProps) {
  return (
    <button
      type={type}
      className={['nyk-ui-iconbtn', active ? 'nyk-ui-active' : '', className].filter(Boolean).join(' ')}
      aria-label={label}
      title={label}
      aria-pressed={active}
      {...rest}
    >
      {children}
      {badge != null && badge !== 0 && badge !== '' && <span className="nyk-ui-badge">{badge}</span>}
    </button>
  );
}
